import { render, staticRenderFns } from "./ProofreadingApplyConfirmDialog.vue?vue&type=template&id=40b30041&scoped=true"
import script from "./ProofreadingApplyConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingApplyConfirmDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingApplyConfirmDialog.vue?vue&type=style&index=0&id=40b30041&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b30041",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b30041')) {
      api.createRecord('40b30041', component.options)
    } else {
      api.reload('40b30041', component.options)
    }
    module.hot.accept("./ProofreadingApplyConfirmDialog.vue?vue&type=template&id=40b30041&scoped=true", function () {
      api.rerender('40b30041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingApplyConfirmDialog.vue"
export default component.exports